import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TableColumnWidthInfo } from '@devexpress/dx-react-grid';

import { statusSet } from './productionComponentInstancesSlice';

interface HistoryGridState {
  readonly projectGuidFilter: string | null;
  readonly checkedRows: string[];
  readonly expandedRows: string[];
  readonly userColumnWidths: TableColumnWidthInfo[] | null;
}

const initialState: HistoryGridState = {
  projectGuidFilter: null,
  checkedRows: [],
  expandedRows: [],
  userColumnWidths: null,
};

const historyGridSlice = createSlice({
  name: 'historyGrid',
  initialState,
  reducers: {
    setProjectGuidFilter: (state, action: PayloadAction<string | null>) => {
      state.projectGuidFilter = action.payload;
      state.checkedRows = [];
      state.expandedRows = [];
    },
    expandRows: (state, action: PayloadAction<readonly string[]>) => {
      for (const rowId of action.payload) {
        if (state.expandedRows.includes(rowId)) continue;
        state.expandedRows.push(rowId);
      }
    },
    collapseRows: (state, action: PayloadAction<readonly string[]>) => {
      state.expandedRows = state.expandedRows.filter((expandedRow) => !action.payload.includes(expandedRow));
    },
    checkRows: (state, action: PayloadAction<readonly string[]>) => {
      for (const rowId of action.payload) {
        if (state.checkedRows.includes(rowId)) continue;
        state.checkedRows.push(rowId);
      }
    },
    uncheckRows: (state, action: PayloadAction<readonly string[]>) => {
      state.checkedRows = state.checkedRows.filter((checkedRow) => !action.payload.includes(checkedRow));
    },
    setUserColumnWidths: (state, action: PayloadAction<TableColumnWidthInfo[]>) => {
      state.userColumnWidths = action.payload;
    },
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(statusSet, (state) => {
      state.checkedRows = [];
    });
  },
});

export const { setProjectGuidFilter, expandRows, collapseRows, checkRows, uncheckRows, setUserColumnWidths } =
  historyGridSlice.actions;
export const historyGrid = historyGridSlice.reducer;
